import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { use } from '@frontend/sports/common/core/utils/router';

import { EmptyComponent } from '../common/empty.component';
import { MultiBuilderBreadcrumbsResolver } from '../multi-builder/multi-builder-breadcrumbs.resolver';
import { MultiBuilderSubnavigationResolve } from '../multi-builder/multi-builder-subnavigation.resolve';
import { MultiBuilderComponent } from '../multi-builder/multi-builder.component';
import { MultiBuilderGuard } from '../multi-builder/multi-builder.guard';
import { MultiBuilderResolver } from '../multi-builder/multi-builder.resolver';
import { SportRoute } from '../router/multi-route.model';
import { nameIdentifierMatcher } from '../router/name-identifier.matcher';
import { SitemapRoutingToken } from '../sitemap/sitemap-routing';
import { MultiBuilderTrackingService } from './multi-builder-tracking.service';
import { MultiBuilderService } from './multi-builder.service';

const routes: SportRoute[] = [
    {
        path: '',
        providers: [
            MultiBuilderService,
            MultiBuilderTrackingService,
            MultiBuilderGuard,
            MultiBuilderBreadcrumbsResolver,
            MultiBuilderSubnavigationResolve,
            MultiBuilderResolver,
        ],
        children: [
            {
                path: '',
                component: EmptyComponent,
                canActivate: [MultiBuilderGuard],
            },
            {
                matcher: nameIdentifierMatcher,
                data: {
                    matcherParam: 'coupon',
                    tag: RouteTag.MultiBuilder,
                    subNavigation: MultiBuilderSubnavigationResolve,
                    breadcrumbs: MultiBuilderBreadcrumbsResolver,
                    sitemap: SitemapRoutingToken.MultiBuilderSitemapResolver,
                    shouldKeepBreadcrumbs: false,
                },
                component: MultiBuilderComponent,
                resolve: use(MultiBuilderResolver),
                canActivate: [MultiBuilderGuard],
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MultiBuilderRoutingModule {}
